import React, { useState } from 'react';
import { Button, ProgressStrip, Skeleton, StepBar, Toast } from '../../components/ui';
import Section from './Section';

/** Second half of the loading gallery: strips, StepBar, skeletons, toasts. */
const LoadingStripsGallery: React.FC = () => {
  const [ctaBusy, setCtaBusy] = useState(false);
  const [toastKey, setToastKey] = useState(0);
  const [toastOn, setToastOn] = useState(true);

  return (
    <>
      <Section title="Loading — progress strip">
        <div className="flex flex-col gap-s4">
          <ProgressStrip
            title="Finding suppliers"
            counts={{ done: 3, running: 4, waiting: 2 }}
            eta={<>about <b className="text-ink">12–16 min</b> more</>}
            end={<Button variant="ghost" size="sm">Open</Button>}
          />
          <ProgressStrip
            tone="attention"
            title="Finding suppliers"
            counts={{ done: 7, running: 0, waiting: 0, attention: 2 }}
            end={<Button size="sm">Retry 2</Button>}
          />
          <ProgressStrip tone="done" title="Suppliers found for 9 components" counts={{ done: 9, running: 0, waiting: 0 }} />
        </div>
      </Section>

      <Section title="Loading — StepBar">
        <div className="relative flex h-[200px] flex-col overflow-auto rounded-card border border-line bg-canvas">
          <div className="flex-1 p-s6 text-body-sm text-ink-secondary">Step content scrolls above the bar.</div>
          <StepBar
            onBack={() => undefined}
            stepLabel="Step 3 · Context"
            summary={<><b className="font-semibold text-ink">9 components</b> · 4 answers still needed</>}
            cta={{
              label: 'Continue to validation',
              loading: ctaBusy,
              loadingLabel: 'Saving…',
              onClick: () => setCtaBusy(true),
            }}
            ctaNote={ctaBusy ? undefined : 'Free — no credits'}
          />
        </div>
        <div className="mt-s4 flex gap-s3">
          <Button variant="secondary" size="sm" onClick={() => setCtaBusy(false)}>Reset CTA</Button>
        </div>
        <div className="mt-s5 overflow-hidden rounded-card border border-line">
          <StepBar
            stepLabel="Step 3 · Discovery · whole BOM"
            summary="0 suppliers shortlisted · shortlist one to continue"
            cta={{ label: 'Continue to outreach', disabled: true }}
          />
        </div>
      </Section>

      <Section title="Loading — skeletons + timed toast">
        <div className="grid grid-cols-1 gap-s7 lg:grid-cols-3">
          <div className="flex flex-col gap-s3">
            <Skeleton width="60%" />
            <Skeleton />
            <Skeleton width="80%" />
          </div>
          <div className="flex flex-col gap-s3">
            <Skeleton shape="block" />
            <Skeleton shape="block" height={28} />
          </div>
          <div className="flex flex-col gap-s3">
            <Skeleton shape="bubble" width="70%" />
            <Skeleton shape="bubble" width="45%" className="self-end" />
            <div className="rounded-card bg-chrome p-s4">
              <Skeleton dark />
            </div>
          </div>
        </div>
        <div className="mt-s7 flex items-start gap-s5">
          {toastOn && (
            <Toast key={toastKey} timed status="success" title="Context saved" message="Validation is ready." onDone={() => setToastOn(false)} />
          )}
          <Button
            variant="secondary"
            size="sm"
            onClick={() => {
              setToastKey((k) => k + 1);
              setToastOn(true);
            }}
          >
            Replay toast
          </Button>
        </div>
      </Section>
    </>
  );
};

export default LoadingStripsGallery;
